import React from 'react'
import './HowToGuideStrip.scss'
import HowToGuideCard from '../HowToGuideCard/HowToGuideCard'
import Heading from '../../Heading/Heading'
import LinkWithArrow from '../../LinkWithArrow/LinkWithArrow'
import Text from '../../Text/Text'

const HowToGuideStrip = ({
  title,
  text,
  howToGuideCards,
  ctaText,
  ctaUrl,
  isExternal
}) => {
  return (
    <>
      <div className="guideMainContainer">
        <div className="textContainer">
          <Heading className="how-to-guide-title">{title}</Heading>
          <Text fontSize="large" className="how-to-guide-text">
            {text}
          </Text>
        </div>
        <div className="guidesCards">
          {howToGuideCards.map((data, i) => (
            <React.Fragment key={i}>
              <HowToGuideCard
                url={data.url}
                image={data.icon.fields.file.url}
                headingText={data.heading}
                description={data.description}
              />
            </React.Fragment>
          ))}
        </div>
        <br />
        <LinkWithArrow to={ctaUrl} external={isExternal}>
          {ctaText}
        </LinkWithArrow>
        <br />
        <br />
      </div>
    </>
  )
}
export default HowToGuideStrip
